import styled from 'styled-components';

const AvatarContainer = styled.div`
    width: fit-content;
    position: relative;

    & > *:last-child {
        position: absolute;
        bottom: 0;
        right: 0;
        box-shadow: 0 0 0 3px white;
    }
`;

export default AvatarContainer;
